<template>
  <div class="mySite">
    <!--顶部-->
    <div class="top">
      <div class="top_inner flex_space">
        <div class="top_innerLeft">
          <div class="img_out">
            <div class="img_in"></div>
          </div>
        </div>
        <div class="top_innerMid">
          <p>牛盾漏洞扫描系统正在保护您的网站</p>
          <div>先黑客一步发现问题</div>
        </div>
        <div class="top_innerRight">
          <div class="title"><i></i>已保护网站</div>
          <div class="num">{{savedTotal}} <span>个</span></div>
        </div>
      </div>
    </div>
    <!--内容部分-->
    <div class="content">
      <!--empty-->
      <div class="emptyDiv" v-if="empty"  v-loading="loading">
      </div>
      <div v-else>
        <!--未添加-->
        <div class="notAdd" v-if="!hasData">
          <p>欢迎使用牛盾漏洞扫描系统</p>
          <div class="addBox">
            <div><i @click="showAddsite"></i></div>
            <p>添加站点，免费扫描</p>
          </div>
        </div>
        <!--已添加-->
        <div class="hasAdd" v-else>
          <!--搜索栏-->
          <div class="search_bar flex_space">
            <div class="left"><i></i>站点管理</div>
            <div class="right">
              <!--搜索框-->
              <el-input placeholder="域名/网站名称" v-model="searchData.inputKeywords" @keyup.enter.native="searchBykey">
                <i slot="suffix" class="el-input__icon el-icon-search" @click="searchBykey"></i>
              </el-input>
              <!-- 检测状态 -->
              <!--<el-select placeholder="检测状态" v-model="searchData.detectStatusData" popper-class="dialogSel_obj"  @change="searchBykey">-->
                <!--<el-option v-for="item in detectStatus" :key="item.id" :value="item.value">-->
                <!--</el-option>-->
              <!--</el-select>-->
              <!-- 访问状态 -->
              <el-select placeholder="验证状态" v-model="searchData.verifyStatusData" popper-class="dialogSel_obj" @change="searchBykey">
                <el-option v-for="item in verifyStatus" :key="item.id" :value="item.value"></el-option>
              </el-select>
            </div>
          </div>
          <!--具体站点内容-->
          <div class="siteMain_wrap">
            <div class="siteMain flex">
              <div class="detailSite" v-for="item in sitesListData" :key="item.id">
                <div class="flex_space">
                  <!--图片左-->
                  <!--<div class="left_img"><img src="../assets/img/test1.png" alt=""></div>-->
                  <!--右边-->
                  <div class="right_con">
                    <div class="flex_space title">
                      <div>{{item.name}}</div>
                      <p v-if="!item.is_valid" class="waitValid"><i></i>待验证</p>
                      <p v-else-if="item.state==2" class="scaning"><i></i>检测中</p>
                      <p v-else-if="item.state==0">待检测</p>
                      <div v-else>
                        <p :class="(item.risk==1)||(item.risk==0)?'commons':'danger'"><i></i>{{risk[item.risk]}}</p>
                        <!--<p class="safe"><i></i>安全</p>-->
                      </div>
                    </div>
                    <div class="siteName">域名: <span class="text_overflow" :title="item.host">{{item.host}}</span></div>
                    <div class="scanTime">扫描时间：{{item.scanned_at?formateDateTime(item.scanned_at):'-'}}</div>
                    <div class=" btn_bar">
                      <button v-if="!item.is_valid" class="btns verify_btn"
                              @click="showVerifyDialog(item.id,item.host)">
                        <i></i>验证
                      </button>
                      <button class="btns scan_btn" v-else @click="startScan(item.id)" :disabled="item.state==2"
                              :class="item.state==2?'disableScanBtn':''"><i></i>扫描
                      </button>
                      <!--state为3则表示扫描已结束，为2则表示正在扫描-->
                      <button class="btns report_btn" @click="openReport(item.id,item.host)" :disabled="!(item.state==3)"
                              :class="item.state==3?'':'disableBtn'"><i></i>报告
                      </button>
                      <button class="btns del_btn" @click="showDelDialog(item.id)" :disabled="item.state==2"
                              :class="item.state==2?'disableDelBtn':''"><i></i>删除
                      </button>
                    </div>
                  </div>
                </div>
                <div class="processBar">
                  <div class="processWrap">
                    <div class="processValue" v-if="item.progress==0"></div>
                    <div v-else-if="item.state==3">
                      <div class="processValue processComplete" :style="{width:'100%'}"></div>
                    </div>
                    <div v-else>
                      <div class="processAnimate flex" v-show="item.progress!=100">
                        <!--进度段-->
                        <div></div>
                        <div></div>
                      </div>
                      <div class="processValue" :class="(item.progress==100)?'processComplete':'processPart'"
                           :style="{width:item.progress+'%'}"></div>
                    </div>
                    <!--以下的进度条是对的处理方式-->
                    <!--<div v-else>-->
                      <!--<div class="processAnimate flex" v-show="item.progress!=100">-->
                        <!--<div></div>-->
                        <!--<div></div>-->
                      <!--</div>-->
                      <!--<div class="processValue" :class="(item.progress==100)?'processComplete':'processPart'"-->
                           <!--:style="{width:item.progress+'%'}"></div>-->
                    <!--</div>-->
                  </div>
                </div>
              </div>
              <p class="hasnoData" v-show="hasNoData">暂无数据</p>
            </div>
            <!--分页栏-->
            <div class="page_bar">
              <el-pagination class="paginationBar" :current-page="pageData.currentPage" @current-change="handlePageNum"
                             background layout="total,prev,pager,next" :total="pageData.total"
                             :page-size="pageData.limit"></el-pagination>
            </div>
            <!--添加按钮-->
            <div class="addSite" @click="showAddsite"></div>
          </div>
        </div>
      </div>

    </div>
    <div class="gw_footerBox">
      <footBar></footBar>
    </div>
    <!--添加站点-->
    <addSites :dialogShow="addSyncDialog" @closeAddDialog="closeaddDialog" @submitSite="submitSites"></addSites>
    <!--待验证对话框-->
    <div class="popUpDialog">
      <el-dialog :visible.sync="waitVerify" :close-on-click-modal="false">
        <div>
          <div class="title_icon"></div>
          <p class="title">待验证</p>
          <p class="title_need">您需要对您添加的站点进行权限认证才能使用漏洞深度扫描功能，请先验证您的站长权限，验证方式如下:</p>
          <div class="file_verify">文件验证</div>
          <p class="download_file">请点击 <a :href="downloadURL" download>下载验证文件</a>
            ，将获取的验证文件放置于你所配置网站(http://www.abc.com)的根目录下，并确定 http://www.abc.com/验证文件名.txt可以访问，然后点击"立即验证"按钮。</p>
        </div>
        <span slot="footer" class="dialog-footer">
           <el-button type="primary" @click="verifyAtonce" :disabled="verifyBtndisable">立即验证</el-button>
         </span>
      </el-dialog>
      <!--确认删除对话框-->
      <el-dialog :visible.sync="delDialogSync" :close-on-click-modal="false" title="确认删除" class="delDialog_wrap">
        <div>
          <p>确认要删除您所选的网站吗？该网站下的所有检测报告也将全部删除！</p>
        </div>
        <span slot="footer" class="dialog-footer">
           <el-button type="primary" @click="submitDel">确定</el-button>
           <el-button @click="closeDelDialog">取消</el-button>
         </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import footBar from '../components/footerbar'
  import addSites from '../components/addSites'
  import axios from 'axios'
  import {getSiteList, delSite} from '../api/api'

  export default {
    data() {
      return {
        savedTotal:'24153',
        hasNoData:false,
        hasData: false, //是否有数据
        empty: true, //空的元素
        loading:true, //加载动画
        addSyncDialog: false,//添加网站对话框
        waitVerify: false,//待验证对话框
        sitesListData: [],
        siteId: '',//单个站点的id
        siteHost: '',//单个站点的host
        verifyBtndisable: false,//立即验证按钮的disable状态
        delDialogSync: false, //确认删除对话框
        downloadURL: '',
        searchData: {
          inputKeywords: '',
          // detectStatusData: '',
          verifyStatusData: ''
        },
        risk: ['一般', '一般', '低危', '中危', '高危', '紧急'],
        inputKeywords: '', //搜索关键字
        detectStatus: [{ //检测状态
          id: 0,
          value: '全部'
        }, {
          id: 1,
          value: '待检测'
        }, {
          id: 2,
          value: '检测中'
        }, {
          id: 3,
          value: '已完成'
        }],
        verifyStatus: [{ //验证状态
          id: 0,
          value: '全部'
        }, {
          id: 1,
          value: '待验证'
        }, {
          id: 2,
          value: '已验证'
        }],
        pageData: {
          currentPage: 1,//当前页码
          limit: 8,//每一页限制条数，每页显示条目个数
          total: 1,//总数
          offset: 0//偏移量
        },
        getlistData:{
          offset:'',
          limit:''
        }
      }
    },
    components: {
      footBar, addSites
    },
    created(){
      this.getlistData['offset'] = this.pageData.offset;
      this.getlistData['limit'] = this.pageData.limit;
      this.getList(this.getlistData);
    },
    methods: {
      formateDateTime(time) {
        //转换时间格式
        let date = new Date(Date.parse(time));
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minute = date.getMinutes();
        month = month < 10 ? "0" + month : month;
        day = day < 10 ? "0" + day : day;
        hour = hour < 10 ? "0" + hour : hour;
        minute = minute < 10 ? "0" + minute : minute;
        return (year + '-' + month + '-' + day + " " + hour + ":" + minute);
      },
      startScan(siteId) {
        //开始扫描
        axios.get('/scan/api/task/start/' + siteId).then(refs => {
          console.log(refs);
          if (refs.data.code == 1) {
            // this.getlistData = {
            //   offset: this.pageData.offset,
            //   limit: this.pageData.limit
            // };
            this.getlistData['offset'] = this.pageData.offset;
            this.getlistData['limit'] = this.pageData.limit;
            this.getList(this.getlistData);
          } else {
            this.$message({
              type: 'error',
              message: refs.data.message
            })
          }
        }).catch(err => {
          console.log(err);
        })
      },
      verifyAtonce() {
        //立即验证
        // console.log(this.siteId);
        this.verifyBtndisable = true;
        axios.get('/scan/api/site/check-id-file?site_id=' + this.siteId).then(refs => {
          // console.log(refs);
          if (refs.data.code == 1) {
            this.$message({
              type: 'success',
              message: '恭喜,您的站点' + this.siteHost + '验证成功！'
            });
            this.waitVerify = false;
            this.verifyBtndisable = false;
            this.getlistData['offset'] = this.pageData.offset;
            this.getlistData['limit'] = this.pageData.limit;
            this.getList(this.getlistData);
          } else {
            this.waitVerify = false;
            this.$message({
              type: 'error',
              message: '您的站点' + this.siteHost + '验证失败！请重新验证'
            })
            this.verifyBtndisable = false;
          }
        }).catch(err => {
          console.log(err);
          this.verifyBtndisable = false;
        })
      },
      showDelDialog(siteId) {
        this.delDialogSync = true;
        this.siteId = siteId;
      },
      submitDel() {
        //删除站点
        let delData = {ids: [this.siteId]};
        delSite(delData).then(refs => {
          console.log(refs);
          if (refs.data.code == 1) {
            this.$message({
              type: 'success',
              message: '站点删除成功'
            });
            this.delDialogSync = false;
            // this.getlistData = {
            //   offset: this.pageData.offset,
            //   limit: this.pageData.limit
            // };
            this.getlistData['offset'] = this.pageData.offset;
            this.getlistData['limit'] = this.pageData.limit;
            this.getList(this.getlistData);
          } else {
            this.$message({
              type: 'error',
              message: refs.data.message
            })
          }
        }).catch(err => {
          console.log(err);
        })
      },
      getList(getData) {
        //得到列表
        getSiteList(getData).then(refs => {
          // axios.get('/scan/api/site/list?offset=' + offset + '&limit=' + this.pageData.limit).then(refs => {
          // console.log(refs);
          if (refs.data.code == 1) {
            // console.log(refs.data.data.length);
            if (refs.data.data.length > 0) {
              this.loading = false;
              this.empty = false;
              this.hasData = true;
              this.sitesListData = refs.data.data;
              this.pageData.total = refs.data.total;
            } else {
              this.empty = false;
              this.loading = false;
              this.hasData = false;
            }
          } else {
            this.empty = false;
            this.loading = false;
            this.$message({
              type: 'error',
              message: refs.data.message
            })
          }
        }).catch(err => {
          console.log(err);
          this.empty = false;
          this.loading = false;
        })
      },
      getListbySearch(getData) {
        //得到列表
        getSiteList(getData).then(refs => {
          if (refs.data.code == 1) {
            this.sitesListData = refs.data.data;
            this.pageData.total = refs.data.total;
            if(refs.data.data.length==0){
              this.hasNoData = true;
            }else{
              this.hasNoData = false;
            }
          } else {
            this.$message({
              type: 'error',
              message: refs.data.message
            })
          }
        }).catch(err => {
          console.log(err);
        })
      },
      // 打开待验证对话框
      showVerifyDialog(siteId, siteHost) {
        this.siteId = siteId;
        this.siteHost = siteHost;
        this.waitVerify = true;
        this.downloadURL = '/scan/api/site/id-file?site_id=' + siteId;
      },
      // 打开报告
      openReport(siteId,host) {
        this.$router.push({name: 'scanReport', query: {id: siteId,hostName:encodeURI(host)}});
      },
      submitSites() {
        //添加站点
        this.addSyncDialog = false;
        this.pageData.currentPage = 1;
        this.getlistData['offset'] = 0;
        this.getlistData['limit'] = this.pageData.limit;
        this.getList(this.getlistData);
      },
      // 关闭添加站点对话框
      closeaddDialog() {
        this.addSyncDialog = false;
      },
      //添加站点对话框
      showAddsite() {
        this.addSyncDialog = true;
      },
      searchBykey() {
        //搜索
        this.pageData.currentPage = 1;
        this.pageData.offset=0;
        this.getlistData= {offset:this.pageData.offset,limit:this.pageData.limit};
        switch(this.searchData.verifyStatusData){
          case '全部':
            this.getlistData['is_valid'] = 0;
            break;
          case '待验证':
            this.getlistData['is_valid'] = 1;
            break;
          case '已验证':
            this.getlistData['is_valid'] = 2;
            break;
        }
        if(this.searchData.inputKeywords){
          this.getlistData['keyword'] = this.searchData.inputKeywords;
        }
        this.getListbySearch(this.getlistData);
      },
      handlePageNum(val) {
        this.pageData.currentPage = val;
        this.pageData.offset = (val - 1) * this.pageData.limit;
        // this.getlistData = {
        //   offset: this.pageData.offset,
        //   limit: this.pageData.limit
        // };
        this.getlistData['offset'] = this.pageData.offset;
        this.getlistData['limit'] = this.pageData.limit;
        this.getList(this.getlistData);
      },
      closeDelDialog() {
        //确认删除对话框关闭
        this.delDialogSync = false;
      }
    }
  }
</script>

<style scoped lang="scss">
  .mySite {
    .top {
      margin-top: 60px;
      height: 300px;
      background: url("../assets/img/mySite/banner.jpg") no-repeat center;
      background-size: cover;
      position: relative;
      .top_inner {
        width: 1160px;
        height: 162px;
        position: absolute;
        bottom: 0;
        left: 50%;
        margin-left: -580px;
        .top_innerLeft {
          width: 278px;
          padding-left: 55px;
          box-sizing: border-box;
          .img_out {
            position: relative;
            width: 223px;
            height: 190px;
            background: url("../assets/img/mySite/glass.png") no-repeat center;
            background-size: 100% 100%;
            .img_in {
              position: absolute;
              width: 164px;
              height: 164px;
              background: url("../assets/img/mySite/glass_inner.gif") no-repeat center;
              background-size: 100% 100%;
              opacity: 0.8;
              left: 3px;
              top: 3px;
            }
          }
        }
        .top_innerMid {
          flex: 1;
          padding-left: 46px;
          text-align: left;
          padding-top: 38px;
          p {
            font-size: 28px;
            color: #404146;
            margin-bottom: 5px;
          }
          div {
            font-size: 20px;
            color: #676767;
          }
        }
        .top_innerRight {
          width: 302px;
          padding-left: 56px;
          padding-top: 38px;
          box-sizing: border-box;
          text-align: left;
          .title {
            i {
              display: inline-block;
              width: 22.89px;
              height: 28.88px;
              background: url("../assets/product.svg") no-repeat -2610.5px -184px;
              vertical-align: middle;
              margin-right: 13px;
            }
            font-size: 20px;
            color: #404146;
          }
          .num {
            font-size: 36px;
            color: #42CD74;
            font-family: 'pingfangBold';
            span {
              font-size: 20px;
              font-family: 'pingfang';
            }
          }
        }
      }
    }
    .content {
      width: 1200px;
      margin: 0 auto;
      .emptyDiv {
        min-height: 560px;
      }
      //未添加
      .notAdd {
        padding-top: 100px;
        padding-bottom: 90px;
        p {
          font-size: 28px;
          color: #404146;
        }
        .addBox {
          width: 500px;
          height: 258.6px;
          border: 1px solid #E9E9E9;
          box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.10);
          border-radius: 3px;
          margin: 39px auto 0;
          div {
            margin: 59px 0 25px;
            i {
              display: inline-block;
              width: 97.66px;
              height: 97.66px;
              background: url("../assets/product.svg") no-repeat -2666px -184px;
              cursor: pointer;
            }
          }
          p {
            font-size: 20px;
            color: #404146;
          }
        }
      }
      //已添加
      .hasAdd {
        padding-top: 30px;
        .search_bar {
          padding-bottom: 5px;
          border-bottom: 1px solid #E9E9E9;
          .left {
            font-size: 18px;
            color: #333;
            i {
              display: inline-block;
              width: 18px;
              height: 18px;
              background: url("../assets/product.svg") no-repeat -2576px -184px;
              vertical-align: middle;
              margin-right: 9px;
            }
          }
          .right {

          }
        }
        .siteMain_wrap {
          padding-bottom: 35px;
          position: relative;
          .siteMain {
            flex-wrap: wrap;
            padding-top: 19px;
            min-height: 430px;
            position:relative;
            .hasnoData{
              position:absolute;
              width:100px;
              left:50%;
              top:20%;
              margin-left:-50px;
              color:#999;
            }
            .detailSite {
              position: relative;
              padding: 17px 20px 0;
              box-sizing: border-box;
              margin-right: 26px;
              width: 279px;
              height: 190px;
              border: 1px solid #E9E9E9;
              box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.10);
              border-radius: 3px;
              margin-bottom: 15px;
              .left_img {
                width: 110px;
                height: 150px;
                img {
                  max-width: 100%;
                  max-height: 100%;
                }
              }
              .right_con {
                flex: 1;
                /*padding-left: 12px;*/
                .title {
                  div {
                    font-size: 18px;
                    color: #333333;
                  }
                  p {
                    font-size: 14px;
                    i {
                      display: inline-block;
                      width: 10px;
                      height: 10px;
                      border-radius: 50%;
                      background: #FF8E02;
                      margin-right: 3px;
                    }
                  }
                  .waitValid {
                    color: #FF8E02;
                  }
                  .scaning, .commons {
                    //扫描中
                    color: #2F87FF;
                    i {
                      background: #2F87FF;
                    }
                  }
                  .danger {
                    //危险
                    color: #F82732;
                    i {
                      background: #F82732;
                    }
                  }
                  .safe {
                    //安全
                    color: #42CD74;
                    i {
                      background: #42CD74;
                    }
                  }
                  margin-bottom: 25px;
                }
                .siteName, .scanTime {
                  font-size: 14px;
                  color: #676767;
                  text-align: left;
                }
                .siteName {
                  margin-bottom: 5px;
                  span{
                    display:inline-block;
                    vertical-align: middle;
                    width:195px;
                  }
                }
                .scanTime {
                  margin-bottom: 15px;
                }
                .btn_bar {
                  text-align: right;
                  .btns {
                    width: 60px;
                    height: 30px;
                    background: #fff;
                    border: 1px solid #E9E9E9;
                    border-radius: 2px;
                    font-size: 12px;
                    color: #333333;
                    padding: 0;
                  }
                  .verify_btn, .report_btn, .del_btn, .scan_btn {
                    i {
                      display: inline-block;
                      width: 14px;
                      height: 12px;
                      background: url("../assets/product.svg") no-repeat -2807px -258.6px;
                      margin-right: 8px;
                      vertical-align: middle;
                    }
                  }
                  .scan_btn {
                    //扫描按钮
                    i {
                      width: 14px;
                      height: 14px;
                      background: url("../assets/product.svg") no-repeat -2806px -184px;
                    }
                  }
                  .report_btn {
                    //报告按钮
                    i {
                      width: 11.56px;
                      height: 14px;
                      background: url("../assets/product.svg") no-repeat -2808px -208px;
                    }
                  }
                  .del_btn {
                    //删除按钮
                    i {
                      width: 14px;
                      height: 14px;
                      background: url("../assets/product.svg") no-repeat -2807px -234px;
                    }
                  }
                  .disableBtn {
                    //报告的按钮上的图片
                    color: #9B9B9B;
                    cursor: not-allowed;
                    i {
                      background: url("../assets/product.svg") no-repeat -2808px -325px;
                    }
                  }
                  .disableDelBtn {
                    //删除按钮上的图片
                    color: #9B9B9B;
                    cursor: not-allowed;
                    i {
                      background: url("../assets/product.svg") no-repeat -2807px -351px;
                    }
                  }
                  .disableScanBtn {
                    //扫描按钮上的图片
                    color: #9B9B9B;
                    cursor: not-allowed;
                    i {
                      background: url("../assets/product.svg") no-repeat -2807px -301px;
                    }
                  }
                }
              }
              &:nth-child(4), &:nth-child(8) {
                margin-right: 0 !important;
              }
            }
          }
          .addSite {
            position: absolute;
            width: 60px;
            height: 60px;
            background: url("../assets/img/mySite/addSite.png") no-repeat center;
            background-size: 100% 100%;
            bottom: 16px;
            right: 0;
            cursor: pointer;
          }
          .page_bar {
            margin-top: 10px;
          }
        }
      }
    }
    .gw_footerBox {
      height: 160px;
    }
  }

  .mySite /deep/ .hasAdd {
    .right {
      .el-input {
        width: 200px;
        height: 35px;
        line-height: 35px;
        .el-input__icon {
          line-height: 35px;
          cursor: pointer;
        }
        .el-input__inner {
          height: 35px;
          line-height: 35px;
          font-family: 'pingfang';
        }
      }
      .el-select {
        .el-input {
          width: 110px;
        }
      }
    }
    .siteMain_wrap {
      .detailSite {
        /*进度条*/
        .processBar {
          .el-progress {
            .el-progress-bar {
              padding-right: 0;
              margin-right: 0;
              .el-progress-bar__outer {
                border-radius: 0;
                background: #E6E6E6;
                .el-progress-bar__inner {
                  border-radius: 0;
                  background-color: #2F87FF;
                }
              }
            }
            .el-progress__text {
              display: none;
            }
          }
          //自己设计的进度
          .processWrap {
            position: relative;
            width: 100%;
            height: 5px;
            background: #E6E6E6;
            margin-top: 15px;
            overflow: hidden;
            .processValue {
              position: absolute;
              /*width:50%;*/
              height: 5px;
              top: 0;
              left: 0;
            }
            .processComplete {
              background: #42CD74;
            }
            .processPart {
              background: #2F87FF;
            }
            .processAnimate {
              height: 5px;
              animation: processGo 3s linear infinite;
              div {
                width: 50px;
                background: #83C6FE;
                opacity: 0.4;
                height: 5px;
                margin-right: 40px;
              }
            }
          }
        }
      }
    }
  }

  @keyframes processGo {
    0% {
      transform: translate3d(-50%, 0, 0);
    }
    100% {
      transform: translate3d(100%, 0, 0);
    }
  }

  @-webkit-keyframes progressGo {

  }

  .popUpDialog {
    .title_icon {
      display: inline-block;
      width: 70px;
      height: 70px;
      background: url("../assets/product.svg") no-repeat -3176px -188px;
      margin-bottom: 5px;
    }
    .title {
      font-size: 20px;
      margin-bottom: 10px;
    }
    .title_need {
      font-size: 14px;
      color: #676767;
      text-align: left;
    }
    .file_verify {
      font-size: 14px;
      color: #404040;
      text-align: left;
      margin: 10px 0 5px;
    }
    .download_file {
      text-align: left;
      font-size: 14px;
      color: #2B2B2B;
    }
  }

  .popUpDialog /deep/ .el-dialog__wrapper {
    .el-dialog {
      width: 560px;
      .el-dialog__footer {
        text-align: center;
      }
    }

  }

  .popUpDialog /deep/ .delDialog_wrap {
    .el-dialog__header {
      text-align: left;
      font-size: 18px;
      color: #000000;
      font-family: 'pingfang';
    }
    .el-dialog__body {
      text-align: left;
      font-size: 14px;
      color: #333333;
      font-family: 'pingfang';
    }
    .el-dialog__footer {
      .el-button {
        width: 200px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mySite.vue